import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const Loader = () => {
  
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    setLoading(true);

    const minDuration = 1000;
    const startTime = Date.now();

    const timeoutId = setTimeout(() => {
      if (Date.now() - startTime >= minDuration) {
        setLoading(false);
        window.scrollTo(0, 0); // Scroll to top after loading
      } else {
        setTimeout(() => {
          setLoading(false);
          window.scrollTo(0, 0);
        }, minDuration - (Date.now() - startTime));
      }
    }, 600); // Base timeout for visual feedback

    return () => clearTimeout(timeoutId); // Cleanup timeout on unmount
  }, [location.pathname]); // Trigger on pathname change

  return (
    <>
      <div>
        {loading && (
          <div id="global-loader">
            <div className="whirly-loader"></div>
          </div>
        )}
      </div>
    </>
  );
};

export default Loader;